// eslint-disable-next-line no-unused-vars
import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Loader, // eslint-disable-line no-unused-vars
  FxBreadcrumbs, // eslint-disable-line no-unused-vars
  callFxgApi,
  FxPageContainer, // eslint-disable-line no-unused-vars
  FxTimeZoneField, // eslint-disable-line no-unused-vars
} from 'axp-fx-common';
import CardPrimary from '../Common/Cards/CardPrimary'; // eslint-disable-line no-unused-vars
// eslint-disable-next-line no-unused-vars
import PageHeader from '../Common/Headers/PageHeader';
import labels from '../../constants/labels';
// eslint-disable-next-line no-unused-vars
import UserAccess from './UserAccess';
import { apiPaths } from '../../constants/paths';
import { userDetailsBreadcrumbs } from '../../constants/breadcrumbs';

const MyAccount = () => {
  const loginData = useSelector((state) => state.getIn([
      'modules',
      'axp-secure-file-express-root',
      'userData',
      'login',
    ])
  );

  const fxgApiHost = useSelector((state) => state.getIn(['config', 'fxgApi']));

  const [userData, setUserData] = useState([]);
  const [showPageLoader, setPageLoader] = useState(false);
  const [isTimeZoneApiLoading, setTimeZoneApiLoading] = useState(false);
  const [timeZones, setTimeZones] = useState([]);

  const dispatch = useDispatch();

  const getTimeZones = useCallback(async () => {
    setTimeZoneApiLoading(true);
    const { response, hasErrors } = await callFxgApi(
      `${fxgApiHost}${apiPaths.timeZoneGetList}`,
      'GET',
      null
    );
    /* istanbul ignore else */
    if (!hasErrors) {
      setTimeZones(response);
    }
    setTimeZoneApiLoading(false);
  }, [fxgApiHost]);

  const handleTimeZoneChange = async (event) => {
    setPageLoader(true);
    const {
      selectedIndex,
    } = event.target;
    const selectedTimeZone = timeZones[selectedIndex];
    const requestData = {
      timeZoneId: selectedTimeZone.timeZoneId,
    };
    await callFxgApi(
      `${fxgApiHost}${apiPaths.saveUserAccountSetting}`,
      'POST',
      requestData
    );
    const newLoginData = { ...loginData };
    newLoginData.userDetail.timeZone = selectedTimeZone;
    dispatch({ type: 'LOGIN_SUCCEEDED', data: newLoginData });
    setPageLoader(false);
  };

  const getUserAttribute = (id, label, value) => ({
    id,
    label,
    value,
  });

  const handleUserAttributes = useCallback(() => {
    const data = [];
    const {
      userFullName,
      emailAddress,
      companyName,
      timeZone = {},
    } = loginData?.userDetail || {};
    const { timeZoneCode } = timeZone;
    data.push(getUserAttribute('name', 'Name', userFullName));
    data.push(getUserAttribute('email', 'Email Address', emailAddress));
    data.push(getUserAttribute('company', 'Company', companyName));
    data.push({
      ...getUserAttribute(
        'defaultTimeZone',
        'Default time zone',
        <FxTimeZoneField
          defaultTimeZone={timeZone}
          timeZones={timeZones}
          handleTimeZoneChange={handleTimeZoneChange}
        />
      ),
      isComponent: true,
    });
    // data.push(getUserAttribute('defaultTz', 'Default Time Zone', defaultTz));
    data.push(getUserAttribute('locale', 'Locale', timeZoneCode));
    setUserData(data);
  }, [loginData, timeZones]); // handleTimeZoneChange is stable

  useEffect(() => {
    handleUserAttributes();
  }, [handleUserAttributes, timeZones]);

  useEffect(() => {
    getTimeZones();
  }, [getTimeZones]);

  return (
    <FxPageContainer>
      <Loader showLoader={showPageLoader} />

      <FxBreadcrumbs breadcrumbItems={userDetailsBreadcrumbs} />

      <PageHeader headerText={labels.USER_DETAILS} />

      <div className="margin-4-t">
        <CardPrimary cardData={userData} isLoading={isTimeZoneApiLoading} />
      </div>

      <UserAccess />

      {/* Not in scope for release 2 */}
      {/* <UserNotificationForm /> */}
    </FxPageContainer>
  );
};

export default MyAccount;
